import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import ProfilePhoto from "../../../components/common/ProfilePhoto";
import toastr from "toastr";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.empStatus) {
    case 'I':
      return 'color3';
    case 'P':
      return 'color5';
    case  'F':
      return 'blue';
    default:
      return '';
  }
}
function dateFormat(cell) {

  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{cell.toDateString()}</font>
  else
    return 'NA';

}

function columnClassNameFinanceStatusFormat(fieldValue, row, rowIdx, colIdx) {
  if (row.financeStatus == null)
    return 'color2';


  return row.financeStatus == 'pending' ? 'color2' : 'color4';
}
function columnClassNameAdminStatusFormat(fieldValue, row, rowIdx, colIdx) {

  if (row.adminStatus == null)
    return 'color2';

  return row.adminStatus == 'pending' ? 'color2' : 'color4';
}
function columnClassNameItStatusFormat(fieldValue, row, rowIdx, colIdx) {
  if (row.itStatus == null)
    return 'color2';

  return row.itStatus == 'pending' ? 'color2' : 'color4';
}

function columnClassNameVerticalHeadStatusFormat(fieldValue, row, rowIdx, colIdx) {
  if (row.vhStatus == null)
    return 'color2';

  return row.vhStatus == 'pending' ? 'color2' : 'color4';
}

function columnClassNameManagerStatusFormat(fieldValue, row, rowIdx, colIdx) {
  if (row.managerStatus == null)
    return 'color2';

  return row.managerStatus == 'pending' ? 'color2' : 'color4';
}
function enumFormatter(cell, row, enumObject) {
  return enumObject[cell];
}
class ExitTable extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {
    const departmentType = {
      "Ad Sales": "Ad Sales",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Application Development": "Application Development",
      "At home beauty service": "At home beauty service",
      "Back Office": "Back Office",
      "BEAUTY": "BEAUTY",
      "Branch Sales": "Branch Sales",
      "Business Development": "Business Development",
      "Business Intelligence": "Business Intelligence",
      "C2C": "C2C",
      "Car & Bike Services": "Car & Bike Services",
      "Carnation": "Carnation",
      "CEO Office": "CEO Office",
      "Channel Partners": "Channel Partners",
      "Content Creation": "Content Creation",
      "Content Moderation": "Content Moderation",
      "Content Review": "Content Review",
      "Corporate Sales": "Corporate Sales",
      "Customer Service": "Customer Service",
      "Customer Support": "Customer Support",
      "Delivery Ops": "Delivery Ops",
      "Delivery Ops - VL": "Delivery Ops - VL",
      "Design": "Design",
      "Digital Marketing": "Digital Marketing",
      "Direct Sales": "Direct Sales",
      "Domain Research": "Domain Research",
      "Doorstep": "Doorstep",
      "Education": "Education",
      "Engineering": "Engineering",
      "Executive Assistant": "Executive Assistant",
      "FINANCE": "FINANCE",
      "Finance and Accounts": "Finance and Accounts",
      "Google Adwords": "Google Adwords",
      "Groups": "Groups",
      "HIREE": "HIREE",
      "HomeVision": "HomeVision",
      "HR": "HR",
      "Human Resource": "Human Resource",
      "Human Resources": "Human Resources",
      "Implementation": "Implementation",
      "Inspection": "Inspection",
      "IRX": "IRX",
      "IT": "IT",
      "IT Infra": "IT Infra",
      "Jobs": "Jobs",
      "Listing Operations": "Listing Operations",
      "Marketing": "Marketing",
      "MGMT": "MGMT",
      "MIS": "MIS",
      "Mobile Development": "Mobile Development",
      "Mobile Exchange": "Mobile Exchange",
      "Offline Content": "Offline Content",
      "oms": "oms",
      "On-Demand Services": "On-Demand Services",
      "online": "online",
      "operation": "operation",
      "Operations": "Operations",
      "PKHD": "PKHD",
      "PLV": "PLV",
      "Product": "Product",
      "Product Monetization": "Product Monetization",
      "Product Operations": "Product Operations",
      "Public Relations": "Public Relations",
      "QA": "QA",
      "Quality": "Quality",
      "Quikr Cars": "Quikr Cars",
      "Quikr Education": "Quikr Education",
      "Quikr Education Sales": "Quikr Education Sales",
      "Quikr Homes": "Quikr Homes",
      "QUIKR JOBS": "QUIKR JOBS",
      "Quikr Service": "Quikr Service",
      "Quikr Services": "Quikr Services",
      "Quikr Services (Groups)": "Quikr Services (Groups)",
      "quikr services (Sales)": "quikr services (Sales)",
      "Quikr X": "Quikr X",
      "Quikrjob": "Quikrjob",
      "Quirk Cars": "Quirk Cars",
      "RE Sales": "RE Sales",
      "RE-Quality": "RE-Quality",
      "Real Estate": "Real Estate",
      "Reality Redefined": "Reality Redefined",
      "Recovery": "Recovery",
      "Renewal": "Renewal",
      "Renewals": "Renewals",
      "Retail": "Retail",
      "Retention": "Retention",
      "Sales": "Sales",
      "Sales Analytics": "Sales Analytics",
      "Sales jobs": "Sales jobs",
      "Sales Operations": "Sales Operations",
      "sales qukr jobs": "sales qukr jobs",
      "Sales Support": "Sales Support",
      "Sales- Car & Bike": "Sales- Car & Bike",
      "Sales-Quikr Services": "Sales-Quikr Services",
      "SELLS": "SELLS",
      "service": "service",
      "Service Provider Operations": "Service Provider Operations",
      "Service Seeker Operations": "Service Seeker Operations",
      "Services": "Services",
      "Services sales": "Services sales",
      "Social Media": "Social Media",
      "Stylist": "Stylist",
      "System Admin": "System Admin",
      "TALLY SALES": "TALLY SALES",
      "Tech": "Tech",
      "Technology": "Technology",
      "Tele Sales": "Tele Sales",
      "Telecalling": "Telecalling",
      "TeleSales": "TeleSales",
      "Trainer": "Trainer",
      "UED": "UED",
      "Video Production": "Video Production",
      "Web Development": "Web Development"
    }
    const locationType = this.props.constants.locationFilter;
    const verticalType = this.props.constants.verticalFilter;
    const payrollType = this.props.constants.payrollFilter;
    const statusType = {
      'P': 'Pending',
      'R': 'Resigned',
      'I': 'Inactive'


    };
    const toeType = {
      'Involuntary': 'Involuntary',
      'Voluntary': 'Voluntary',
      'Abscond' : 'Abscond'
    }
    const noeType = {
      'Serving': 'Serving',
      'Waived_Off': 'Waived Off',
      'Gardening': 'Gardening',
      'Recover': 'Recover',
      'Termination' : 'Termination',
      'Business' : 'Business'
    }
    const runningStatusType = {
      'pending': 'Pending',
      'Completed': 'Completed'

    };
    const functionType = {
      "Ad Monetisation": "Ad Monetisation",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Beauty": "Beauty",
      "Finance and Accounts": "Finance and Accounts",
      "Human Resource": "Human Resource",
      "IT": "IT",
      "MGMT": "MGMT",
      "Marketing": "Marketing",
      "Operations": "Operations",
      "Product": "Product",
      "Product Monetization": "Product Monetization",
      "Public Relations": "Public Relations",
      "Sales": "Sales",
      "Technology": "Technology",
      "UED": "UED"
    };

    const subDepartmentType = {
      "1800 Miss Call": "1800 Miss Call",
      "AD_Posting": "AD_Posting",
      "Activation": "Activation",
      "Ad - Operations": "Ad - Operations",
      "Ad Monetisation": "Ad Monetisation",
      "Ad Sales": "Ad Sales",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Android": "Android",
      "Android- Escrow": "Android- Escrow",
      "Application Development": "Application Development",
      "Beauty": "Beauty",
      "Bike_Calling": "Bike_Calling",
      "Bike_Procurement": "Bike_Procurement",
      "Bike_Selling": "Bike_Selling",
      "Book Now": "Book Now",
      "Brand Marketing": "Brand Marketing",
      "Business Development": "Business Development",
      "Business Intelligence": "Business Intelligence",
      "Call Quality & Lead Inspection": "Call Quality & Lead Inspection",
      "Caller": "Caller",
      "Car Inspection": "Car Inspection",
      "Car Verified Leads": "Car Verified Leads",
      "Car_Services_Finances": "Car_Services_Finances",
      "Channel Partner": "Channel Partner",
      "Channel Partners": "Channel Partners",
      "Chat": "Chat",
      "Collecting Information": "Collecting Information",
      "Content": "Content",
      "Content & Research": "Content & Research",
      "Content Creation": "Content Creation",
      "Content Moderation": "Content Moderation",
      "Content Research": "Content Research",
      "Content Review": "Content Review",
      "Corporate Sales": "Corporate Sales",
      "Customer Operations": "Customer Operations",
      "Customer Service": "Customer Service",
      "Customer Support": "Customer Support",
      "Customer Support - TL": "Customer Support - TL",
      "Data Collection": "Data Collection",
      "Data Entry": "Data Entry",
      "Dealer Procurement Program (DPP)": "Dealer Procurement Program (DPP)",
      "Delivery Ops": "Delivery Ops",
      "Design": "Design",
      "Digital Marketing": "Digital Marketing",
      "Digital Marketing - SEM": "Digital Marketing - SEM",
      "Digital Marketing - SEO": "Digital Marketing - SEO",
      "Direct Sales": "Direct Sales",
      "Doorstep": "Doorstep",
      "Email Marketing": "Email Marketing",
      "Email Support": "Email Support",
      "Engagement Management": "Engagement Management",
      "Escrow": "Escrow",
      "Executive Assistant": "Executive Assistant",
      "Finance": "Finance",
      "Finance and Accounts": "Finance and Accounts",
      "Goods": "Goods",
      "Google Adwords": "Google Adwords",
      "Groups": "Groups",
      "H2H": "H2H",
      "HR": "HR",
      "HomeVision": "HomeVision",
      "Horizontal": "Horizontal",
      "Human Resource": "Human Resource",
      "IRX": "IRX",
      "IT": "IT",
      "IT Infra": "IT Infra",
      "Implementation": "Implementation",
      "Inspection Calling": "Inspection Calling",
      "Jobs/Profile creation": "Jobs/Profile creation",
      "Jobs/Recruitment": "Jobs/Recruitment",
      "Lead Generation": "Lead Generation",
      "Lead generation ": "Lead generation ",
      "Listing Operations": "Listing Operations",
      "Logistics": "Logistics",
      "MGMT": "MGMT",
      "MIS": "MIS",
      "Management": "Management",
      "Market Research": "Market Research",
      "Marketing": "Marketing",
      "Mobile Development": "Mobile Development",
      "Monetization": "Monetization",
      "Monetization/Escrow": "Monetization/Escrow",
      "OBD_Services": "OBD_Services",
      "OMS": "OMS",
      "On-Demand Services": "On-Demand Services",
      "Operations": "Operations",
      "PKHD": "PKHD",
      "PLV": "PLV",
      "PLV + Activation (Blended)": "PLV + Activation (Blended)",
      "Payment": "Payment",
      "Premium Support- Inbound": "Premium Support- Inbound",
      "Premium Support- Outbound": "Premium Support- Outbound",
      "Product": "Product",
      "Product Management": "Product Management",
      "Product Monetization": "Product Monetization",
      "Product Operations": "Product Operations",
      "Public Relations": "Public Relations",
      "QA": "QA",
      "QA-CR": "QA-CR",
      "Quality": "Quality",
      "Quality and Product Analytics": "Quality and Product Analytics",
      "Quikr X": "Quikr X",
      "Quikr X - TL": "Quikr X - TL",
      "Quikr.com": "Quikr.com",
      "QuikrX": "QuikrX",
      "Quikr_Stepni": "Quikr_Stepni",
      "RTO Services": "RTO Services",
      "Reality Redefined": "Reality Redefined",
      "Recovery": "Recovery",
      "Recovery & Renewals": "Recovery & Renewals",
      "Renewal": "Renewal",
      "Replies": "Replies",
      "SE - PCS - Email": "SE - PCS - Email",
      "SE - PCS - Inbound": "SE - PCS - Inbound",
      "SE - PCS - Inbound + Email": "SE - PCS - Inbound + Email",
      "SE - PCS - Outbound": "SE - PCS - Outbound",
      "SE - PCS - Outbound - IR": "SE - PCS - Outbound - IR",
      "SE - PCS - Outbound - Listings": "SE - PCS - Outbound - Listings",
      "SE - PCS - Outbound - RM": "SE - PCS - Outbound - RM",
      "SE - PCS - Outbound - VL": "SE - PCS - Outbound - VL",
      "SE - PCS - Sales Audit": "SE - PCS - Sales Audit",
      "SE - PCS - Sales Helpdesk": "SE - PCS - Sales Helpdesk",
      "SE - Training": "SE - Training",
      "SFM": "SFM",
      "SFM - Ad Posting": "SFM - Ad Posting",
      "SFM - Escalations": "SFM - Escalations",
      "SFM - RM": "SFM - RM",
      "SFM- Ad Posting": "SFM- Ad Posting",
      "Sales": "Sales",
      "Sales Analytics": "Sales Analytics",
      "Sales Operations": "Sales Operations",
      "Sales Support": "Sales Support",
      "Sales-RE": "Sales-RE",
      "Scheduling": "Scheduling",
      "Scheduling / Payment": "Scheduling / Payment",
      "Service Provider Operations": "Service Provider Operations",
      "Service Seeker Operations": "Service Seeker Operations",
      "Services": "Services",
      "Social Marketing": "Social Marketing",
      "Social Media Support": "Social Media Support",
      "Stylist": "Stylist",
      "Technology": "Technology",
      "Telesales": "Telesales",
      "Trainer": "Trainer",
      "UDAAN": "UDAAN",
      "UED": "UED",
      "UED - Centralized Ideation": "UED - Centralized Ideation",
      "UED - Content": "UED - Content",
      "UED - Creative Marketing": "UED - Creative Marketing",
      "UED - Escrow": "UED - Escrow",
      "UED - Quikr X": "UED - Quikr X",
      "UED – Emailers": "UED – Emailers",
      "UED – Mobile App": "UED – Mobile App",
      "VL Delivery": "VL Delivery",
      "Web Development": "Web Development"
    }

    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    return (
      <div>
        <br/>
        <hr/>
        <BootstrapTable
          exportCSV={true}
          containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
          headerStyle={{
            borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
            , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
          }}
          search={true}
          striped
          options={options}
          pagination
          data={this.props.employees}>
          <TableHead isKey={false}
                     hidden={false}
                     columnClassName="leftRightZero"
                     width={80}
                     dataFormat={(cell, row)=> {
                       if (row.empStatus == 'I')
                         return <div>
                           <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Full & Final</Tooltip>}>
                             <img
                               style={{cursor: 'pointer'}}
                               onClick={()=> {
                                 this.props.edit(row);
                                 this.props.openfnf();
                               }}
                               src="/public/images/edit.png"></img>
                           </OverlayTrigger></div>;
                       else if (row.empStatus == 'F')
                         return <div>
                           <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Completed</Tooltip>}>
                             <img
                               style={{cursor: 'pointer'}}
                               onClick={()=> {

                                 toastr.info("Exit Process Complete");
                               }
                               }
                               src="/public/images/edit.png"></img>
                           </OverlayTrigger>
                           </div>;

                          else if (row.type_of_exit == 'abscond')
                          return <div style={{padding: 0}}>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                              <img
                                style={{cursor: 'pointer'}}
                                onClick={()=> {
                                  if (row.empStatus == "I") {
                                    toastr.info("Employee is inactive");
                                    return;
                                  }
                                  
                                  this.props.edit(row);
                                  this.props.open();
                                }
                                }
                                src="/public/images/edit.png"></img>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">De-Activate</Tooltip>}>
                              <img
                                onClick={()=> {
                                  if (row.empStatus == "I") {
                                    toastr.info("Employee is inactive");
                                    return;
                                  }
                                  else if (row.empStatus == 'P') {
                                    toastr.info("Pending Approval");
                                    return;
                                  }

                                  this.props.edit(row);
                                  this.props.openExit();
                                }
                                }
                                style={{cursor: 'pointer', paddingLeft: '8px'}}
                                src="/public/images/error.png"></img>
                            </OverlayTrigger>
                          
                          </div>;

                       return <div style={{padding: 0}}>
                         <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                           <img
                             style={{cursor: 'pointer'}}
                             onClick={()=> {
                               if (row.empStatus == "I") {
                                 toastr.info("Employee is inactive");
                                 return;
                               }
                               else if (row.empStatus == 'P') {
                                 toastr.info("Pending Approval")
                                 return;
                               }
                               this.props.edit(row);
                               this.props.open();
                             }
                             }
                             src="/public/images/edit.png"></img>
                         </OverlayTrigger>

                         <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">De-Activate</Tooltip>}>
                           <img
                             onClick={()=> {
                               if (row.empStatus == "I") {
                                 toastr.info("Employee is inactive");
                                 return;
                               }
                               else if (row.empStatus == 'P') {
                                 toastr.info("Pending Approval");
                                 return;
                               }

                               this.props.edit(row);
                               this.props.openExit();
                             }
                             }
                             style={{cursor: 'pointer', paddingLeft: '8px'}}
                             src="/public/images/error.png"></img>
                         </OverlayTrigger>

                       </div>
                     }}
                     dataField="Id"> </TableHead>


          <TableHead dataSort={true}
                     isKey={true}
                     hidden={false}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Id'} }
                     width={100}
                     columnClassName={ columnClassNameFormat }
                     dataField="employeeCode">Id</TableHead>
          <TableHead dataSort={true}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                     columnClassName={ columnClassNameFormat }
                     width={140} dataField="name"
                     dataFormat={(cell, row)=> {
                       return <OverlayTrigger trigger={['hover']} placement="top" overlay={<Popover>
                         <ProfilePhoto height="150px" width="150px" empno={row.employeeCode}/></Popover>}>
                         <a onClick={()=> {
                           this.props.edit(row);
                           this.props.trueDisable();
                         }}>{cell}</a>
                       </OverlayTrigger>
                     }}>Name</TableHead>
          <TableHead isKey={false}
                      hidden={false}
                      columnClassName={ columnClassNameManagerStatusFormat }
                      width={80}
                      style={{textAlign: 'center'}}
                      dataFormat={(cell, row)=> {
                        if(row.imageUrl){
                          return <div>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltipImage">Exit Image</Tooltip>}>
                              <img
                                style={{cursor: 'pointer'}}
                                onClick={()=> {
                                   this.props.viewImage(row);
                                }}
                                src="/public/images/imageView.png" width="40"></img>

                            </OverlayTrigger>
                          </div>;
                        }else{
                          return <div></div>
                        }
                     }}
                     dataField="Id">Image</TableHead>
          <TableHead dataField="vhStatus"
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'VH Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}
                     columnClassName={ columnClassNameVerticalHeadStatusFormat }>VH
            <br/>Status
          </TableHead>
          <TableHead dataField="managerStatus"
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'Manager Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}
                     columnClassName={ columnClassNameManagerStatusFormat }
          >Manager
            <br/>Status</TableHead>
          <TableHead dataField="itStatus"
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'It Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}
                     columnClassName={ columnClassNameItStatusFormat }
          >IT<br/> Status</TableHead>
          <TableHead dataField="adminStatus"
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'Facilities Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}
                     columnClassName={ columnClassNameAdminStatusFormat }
          >Facilities<br/> Status</TableHead>
          <TableHead dataField="financeStatus"
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'Finance Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}
                     columnClassName={ columnClassNameFinanceStatusFormat }
          >Finance<br/> Status</TableHead>

          <TableHead dataField="doR"
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != 'NA' && cell != 0)
                         return <font >{new Date(cell).toDateString()}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={120}>Date of<br/> Resignation</TableHead>


          <TableHead dataField="doL"
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != 'NA' && cell != 0)
                         return <font >{new Date(cell).toDateString()}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={120}>Last Working <br/>Day</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: statusType, placeholder: 'Status'} }
                     dataFormat={this.checkNull}
                     width={100}
                     dataField="empStatus">Status</TableHead>


          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: noeType, placeholder: 'Notice Period Status'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="noticePeriodStatus">Notice Period<br/> Status</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: toeType, placeholder: 'Type Of Exit'} }
                     dataFormat={this.checkNull}
                     width={100}
                     dataField="type_of_exit">Type Of<br/>Exit</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'EmailId'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="emailId">Email Id</TableHead>

          <TableHead dataField="designation"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Designation'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={160}>Designation</TableHead>
          <TableHead dataField="department"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: departmentType, placeholder: 'Department'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Department</TableHead>
          <TableHead dataField="subDepartment"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: subDepartmentType, placeholder: 'Sub Dept'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Sub-Department</TableHead>
          <TableHead dataField="function"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: functionType, placeholder: 'Function'} }
                     dataFormat={this.checkNull}
                     filterFormatted
                     dataSort={true}
                     width={150}>Function</TableHead>
          <TableHead dataField="vertical"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: verticalType, placeholder: 'Function'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={false}
                     width={100}>Vertical</TableHead>
          <TableHead dataField="verticalheadName"
                     columnClassName={ columnClassNameFormat }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={false}
                     width={140}>Vertical<br/>Head</TableHead>
          <TableHead dataField="location"
                     filter={ {type: 'SelectFilter', options: locationType, placeholder: 'Location'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={120}>Location</TableHead>
          <TableHead dataField="payroll"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'SelectFilter', options: payrollType, placeholder: 'Payroll'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={120}>Payroll</TableHead>


          <TableHead dataField="department"
                     columnClassName={ columnClassNameFormat }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     hidden={true}
                     width={100}>Vertical</TableHead>

          <TableHead dataField="managerName"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Manager name'} }
                     dataFormat={(cell, row, formatExtraData, rowIdx)=> {
                       return cell;
                     }}
                     dataSort={true}
                     width={150}>Reporting to</TableHead>

          <TableHead dataField="reportingTo"
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: "ManagerID"} }
                     dataFormat={(cell, row, formatExtraData, rowIdx)=> {
                       return cell;
                     }}
                     dataSort={true}
                     width={120}>ManagerId</TableHead>
          <TableHead dataField="remarks" hidden={true} export={true}/>
          <TableHead dataField="dateOfJoining"
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != " " && cell != 0)
                         return <font>{new Date(cell).toDateString()}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={260}>Date of Joining</TableHead>


        </BootstrapTable>

      </div>
    );
  }
}

ExitTable.propTypes = {};

export default ExitTable;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Exit/ExitTable.js
 **/